export default "__VITE_ASSET__BWOsyZdL__"